module.exports = __webpack_public_path__ + "img/play-circle.23e37f37.svg";